export default __webpack_public_path__ + "src/assets/images/purchase/default-screenshot-gc.png";